import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {Box, Card, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import SuccessLogo from "../../assets/success.svg";
import ErrorLogo from "../../assets/error.svg";
import {PrimaryBigButton} from "../../components/buttons/mainButton";
import {PRIVATE_URL} from "../../common/struct/urlManager";
import {LibertyTheme} from "../../tokens/libertyTheme";
import {Loader} from "../../components/loader/loader";

export default function PaymentSuccess(): JSX.Element {

  const navigate = useNavigate();
  const {t} = useTranslation();
  const {search} = useLocation();
  const searchParams = new URLSearchParams(search);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string|null>(null);
  const [message, setMessage] = useState<string|null>(null);

  useEffect(() => {
    extractMessage();
    setLoading(false);
  }, [])

  const extractMessage = (): void => {
    switch (searchParams.get('redirect_status')) {
    case 'succeeded':
      setMessage(t("payment.success"));
      break;
    case 'processing':
      setMessage(t("payment.ongoing"));
      break;
    default:
      setError(t("payment.error"));
      break;
    }
  }

  const redirectToCustomisation = (): void => {
    navigate(PRIVATE_URL.WALLETS_BUY_POINTS);
  }
  
  const backgroundColor = error ? `linear-gradient(to right, #f1c6c6, ${LibertyTheme.palette.error.light})` : `linear-gradient(to right, #C6F1E8, ${LibertyTheme.palette.success.light})`;
  return loading ? <Loader /> :
    <Card sx={{boxShadow: 2, mt: "10vh", width: "40%", mx: "auto"}}>
      <Box sx={{display: "flex", flexDirection: "column", alignItems: "center"}}>
        <Box sx={{p: 6, width: "100%", boxSizing: "border-box", display: "flex", alignItems: "center", background: backgroundColor}}>
          {/* @ts-ignore */}
          <img src={error ? ErrorLogo : SuccessLogo} alt="payment-success"/>
          <Box sx={{display: "flex", flexDirection: "column", ml: 2}}>
            <Typography variant="h2" color="neutral.dark" sx={{fontWeight: "bold", mb: 1}}>
              {error??message}
            </Typography>
            <Typography variant="body2" color="neutral.main">
              {error ? t("payment.error_explanation") : t("payment.success_explanation")}
            </Typography>
          </Box>
        </Box>
        <PrimaryBigButton label={t("navigation.back_to_customisation")} action={redirectToCustomisation} sx={{my: 5}}/>
      </Box>
    </Card>
}